module.exports = __webpack_public_path__ + "static/media/labels.dc5b1f59.png";